import i18next from "i18next";
import i18nBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import axios from "axios";

const initI18n = async () => {
  try {
    const response = await axios.get(
      "https://api.gamerji.tech/api/bucket/url"
    );

    const imageBaseUrl = response?.data?.url
    // response?.data?.url?.replace(/\/+$/, "") || "";

    const baseUrl = `${imageBaseUrl}/languages/${process.env.REACT_APP_CC}/${process.env.REACT_APP_ENVIORMENT}/`.toLowerCase();

    console.log(
      "LANGUAGE JSON URL >>>",
      `${baseUrl}{{lng}}.json`
    );

    await i18next
      .use(i18nBackend)
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        fallbackLng: "en",
        load: "languageOnly",
        debug: true,

        interpolation: {
          escapeValue: false,
        },

        detection: {
          order: [
            "querystring",
            "cookie",
            "localStorage",
            "path",
            "navigator",
          ],
          caches: ["localStorage"],
          lookupLocalStorage: "i18nextLng",
          lookupCookie: "i18next",
        },

        backend: {
          loadPath: `${baseUrl}{{lng}}.json`,
        },

        react: {
          useSuspense: true,
        },
      });

    return i18next;
  } catch (error) {
    console.error("i18n initialization failed:", error);
    return i18next;
  }
};

export default initI18n;